
import React, {useState, useEffect} from 'react';
import './App.css';


function Time() {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    var interval = setInterval(() => setDate(new Date()), 1000)

    return function reset() {
        clearInterval(interval)
    }
});

return(
  <div>
    <h2 className='clock'>{date.toLocaleTimeString()}</h2>
      <p className="date">{date.toLocaleDateString()}</p>
  </div>
);
}

function Weather() {
  const [lat, setLat] = useState([]);
  const [long, setLong] = useState([]);
  const [temp, setTemp] = useState({});
  const [desc, setDesc] = useState({});
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      navigator.geolocation.getCurrentPosition(function(position) {
        setLat(position.coords.latitude);
        setLong(position.coords.longitude);
      });

      fetch(`https://api.openweathermap.org/data/2.5/weather/?lat=${lat}&lon=${long}&units=metric&APPID=62c148ae55ed7fef4987426581403977`)
      .then(res => res.json())
      .then(result => {
        setTemp(result.main);
        setDesc(((result.weather)[0]));
      })
      .catch(err => setMessage("Loading failed. Please refresh."));
    }
    fetchData(); 
  }, [lat,long]);

  if (temp === undefined | desc === undefined) {
    return <p>{message}</p>
  }

    return(
      <div className="weather-box">
      <p className="temp">{((temp.temp * 1.8) + 32).toFixed(1) + '\u00b0' + " F"}</p>
      <p>{'\u00B7'}</p>
      <p className="weather-desc">{desc.description}</p>
      </div>
    );
}

function TimeWeather() {
  return(
    <div>
    <Time />
    <Weather />
    </div>
  );
}

export default TimeWeather;